import { Box, CircularProgress, Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import httpclient from "../../utils";
import WarehouseCard from "../../Components/Warehouse/WarehouseCard";
import { useParams } from "react-router-dom";

const Warehouse = () => {
  const {id} = useParams();
  const [warehouseList, setWarehouseList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getWarehouseList();
    //sessionStorage.clear();
  }, []);

  const getWarehouseList = () => {
    setLoading(true);
    httpclient
      .get(`wms/warehouse/list?warehouseID=${id}`)
      .then(({ data }) => {
        if (data.success) {
          setWarehouseList(data.records.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);

      });
  };

  return (
    <div>
      <Container maxWidth="xl">
        <Box mb={3} textAlign="center">
          <h2>PSW Warehouse</h2>
        </Box>
        <Grid container spacing={4}>
          {!loading ? (
            warehouseList &&
            warehouseList.map((warehouse) => (
              <Grid item xs={12} md={4} sm={6} key={warehouse.id}>
                <WarehouseCard warehouse={warehouse} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default Warehouse;
